import { Icon as SemanticIcon } from 'semantic-ui-react';

export { IconProps, StrictIconProps } from 'semantic-ui-react';

export const Icon: typeof SemanticIcon = SemanticIcon;

export default Icon;
